var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1787 15.847L14.7186 18.9521C14.9284 19.3843 15.4884 19.7989 15.9609 19.8784L18.7519 20.346C20.5366 20.6458 20.9566 21.9514 19.6705 23.2393L17.5008 25.4269C17.1333 25.7975 16.932 26.5119 17.0458 27.0237L17.6669 29.7318C18.1569 31.8754 17.0283 32.7046 15.1472 31.5843L12.5312 30.0229C12.0588 29.7405 11.2801 29.7405 10.7989 30.0229L8.18298 31.5843C6.31068 32.7046 5.17331 31.8665 5.66325 29.7318L6.28443 27.0237C6.39818 26.5119 6.19694 25.7975 5.82949 25.4269L3.65972 23.2393C2.38237 21.9514 2.79357 20.6458 4.57837 20.346L7.36931 19.8784C7.83302 19.7989 8.39295 19.3843 8.60293 18.9521L10.1428 15.847C10.9827 14.1621 12.3475 14.1621 13.1787 15.847Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0837 2.91666L20.417 14.5833M23.3337 2.91666L16.042 10.2083M29.167 14.5833L24.792 18.9583",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendProfile);
export default __webpack_public_path__ + "static/media/RecommendProfile.9acc17ae27a522854d6ee39a704b6516.svg";
export { ForwardRef as ReactComponent };